export interface IPairInfoRequest {
    address: string; //POOL ADDRESS
    network: "ton"; //always TON
}

export interface INetwork {
    name: string;
    chain_id: number;
}

export interface IDex {
    name: string;
    factory: string;
    chain_id: number;
    lp_token_symbol: string;
}

export interface IToken {
    name: string;
    symbol: string;
    address: string;
    chain_id: number;
    price_usd: number;
    price_native: number;
    position: number;
    decimals: number;
    reserve: number;
    total_supply: number;
    is_native?: boolean; // Optional property to identify native tokens like TON
}

export interface ITransactionCount {
    buys: number;
    sells: number;
}

export interface ITransactions {
    m5: ITransactionCount;
    h1: ITransactionCount;
    h6: ITransactionCount;
    h24: ITransactionCount;
}

export interface IVolume {
    m5: number;
    h1: number;
    h6: number;
    h24: number;
}

export interface IPriceChange {
    m5: number;
    h1: number;
    h6: number;
    h24: number;
}

export interface IPairInfoResponse {
    dex: IDex;
    liquidity_usd: number;
    network: INetwork;
    pair_address: string;
    pair_created_at: string;
    price_change: IPriceChange;
    ticker: string;
    tokens: IToken[];
    transaction_fee: number;
    txn: ITransactions;
    volume: IVolume;
}

export class AviproductionPairApi {
    private static basePath = "https://api.aviproduction.org/api/v1/dex/pair-info";

    public static async getPairPairInfo(req: IPairInfoRequest): Promise<IPairInfoResponse | null> {
        let urlString = `${AviproductionPairApi.basePath}`;

        try {
            const resp = (await fetch(urlString, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    address: req.address,
                    network: req.network,
                }),
            }).then((res) => res.json())) as IPairInfoResponse;
            return resp;
        } catch (error) {
            console.error("Error fetching pair info:", error);
            return null;
        }
    }
}
